
                import "css-modules://src_components_header"
                export default {"Main":"_68f6d6","Inner":"_cdc81a"}
            